export const USER_SETTINGS = 'user_settings';
export const LOCAL_USER_DATA = 'user_data';
export const REMEMBER_ME_DATA = 'remember_me_data';
export const USER_ROLE = 'user_role';
export const LOGIN_TIMESTAMP = 'LOGIN_TIMESTAMP';
export const USER_DATA = 'user_data_login';
export const USER_DETAILS_DATA = 'user_details_data';
export const USER_SITE_ID = 'USER_SITE_ID';

export enum DISABLED_FEATURE {
    MANAGE_USER = 'manageuser',
    MANAGE_LOCATION_SITE = 'managelocationsite',
    SHOW_PPE_LEVEL = 'ppeLevel',
}
